module.exports = false;



//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1